import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { filter, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PartnerProgram } from '@api/models/B2bService/Contract/partner-program';
import { RouteEntity } from '@core/router/route.entity';
import { RoutingQueryParamsName } from '@core/router/routing.params';
import { B2bProgramsState } from '../../state/b2b-programs-state';


/**
 * Service for obtaining detailed data of B2b programs (Resolver)
 */
@Injectable({
    providedIn: 'root',
})
export class B2bProgramResolverService {
    private readonly b2bProgramsState: B2bProgramsState = inject(B2bProgramsState);
    private readonly router: Router = inject(Router);

    public resolve(
        route: ActivatedRouteSnapshot,
    ): Observable<PartnerProgram> | Observable<never> {
        const id: number = Number(route.paramMap.get(RoutingQueryParamsName.PrgId));

        return id === null || id === undefined ? null : this.b2bProgramsState.programs$.pipe(
            filter(Boolean),
            map((programs: PartnerProgram[]) => {
                const program: PartnerProgram = programs.find((item: PartnerProgram) => item.prgId === id);

                if (program) {
                    return program;
                } else {
                    this.router.navigate([RouteEntity.Root, RouteEntity.Error, RouteEntity.Error404]);
                }
            }),
        );
    }
}
